import type { paths } from '@orlikfy/api-interfaces';

export type {
  CreateHostedGameDto,
  CreateHostedGamePlaceholderPlayerDto,
  CreateReassignTokenResponseDto,
  HostedGameDetailsDto,
  HostedGameDtoLocation,
  HostedGameInvitationDto,
  HostedGamePlayerApplicationDto,
  HostedGamePlayerDto,
  HostedGameDto,
  HostedGameItemDto,
  RemoveGamePlayerDto,
  UpdatePartialHostedGameDto
} from '@orlikfy/api-interfaces';

// POST /hosted-games
export const CREATE_HOSTED_GAME_PATH = '/hosted-games' as const satisfies keyof paths;
type CreateHostedGameOperation = paths[typeof CREATE_HOSTED_GAME_PATH]['post'];
export type CreateHostedGameBody = CreateHostedGameOperation['requestBody']['content']['application/json'];
export type CreateHostedGameResponse = CreateHostedGameOperation['responses'][200]['content']['application/json'];

// PATCH /hosted-games/{hostedGameId}
export const UPDATE_HOSTED_GAME_PATH = '/hosted-games/{hostedGameId}' as const satisfies keyof paths;
type UpdateHostedGameOperation = paths[typeof UPDATE_HOSTED_GAME_PATH]['patch'];
export type UpdateHostedGamePathParams = UpdateHostedGameOperation['parameters']['path'];
export type UpdateHostedGameBody = UpdateHostedGameOperation['requestBody']['content']['application/json'];
export type UpdateHostedGameResponse = UpdateHostedGameOperation['responses'][200]['content']['application/json'];

// GET /hosted-games/{hostedGameId}
export const GET_HOSTED_GAME_PATH = '/hosted-games/{hostedGameId}' as const satisfies keyof paths;
type GetHostedGameOperation = paths[typeof GET_HOSTED_GAME_PATH]['get'];
export type GetHostedGamePathParams = GetHostedGameOperation['parameters']['path'];
export type GetHostedGameResponse = GetHostedGameOperation['responses'][200]['content']['application/json'];

// DELETE /hosted-games/{hostedGameId}
export const CANCEL_HOSTED_GAME_PATH = '/hosted-games/{hostedGameId}' as const satisfies keyof paths;
type CancelHostedGameOperation = paths[typeof CANCEL_HOSTED_GAME_PATH]['delete'];
export type CancelHostedGamePathParams = CancelHostedGameOperation['parameters']['path'];

// DELETE /hosted-games/{hostedGameId}/players/{gamePlayerId}
export const REMOVE_GAME_PLAYER_PATH =
  '/hosted-games/{hostedGameId}/players/{gamePlayerId}' as const satisfies keyof paths;
type RemoveGamePlayerOperation = paths[typeof REMOVE_GAME_PLAYER_PATH]['delete'];
export type RemoveGamePlayerPathParams = RemoveGamePlayerOperation['parameters']['path'];

// POST /hosted-games/{hostedGameId}/players/{gamePlayerId}/mark-as-paid
export const MARK_GAME_PLAYER_AS_PAID_PATH =
  '/hosted-games/{hostedGameId}/players/{gamePlayerId}/mark-as-paid' as const satisfies keyof paths;
type MarkGamePlayerAsPaidOperation = paths[typeof MARK_GAME_PLAYER_AS_PAID_PATH]['post'];
export type MarkGamePlayerAsPaidPathParams = MarkGamePlayerAsPaidOperation['parameters']['path'];

// POST /hosted-games/{hostedGameId}/players/{gamePlayerId}/mark-as-not-paid
export const MARK_GAME_PLAYER_AS_NOT_PAID_PATH =
  '/hosted-games/{hostedGameId}/players/{gamePlayerId}/mark-as-not-paid' as const satisfies keyof paths;
type MarkGamePlayerAsNotPaidOperation = paths[typeof MARK_GAME_PLAYER_AS_NOT_PAID_PATH]['post'];
export type MarkGamePlayerAsNotPaidPathParams = MarkGamePlayerAsNotPaidOperation['parameters']['path'];

// POST /hosted-games/{hostedGameId}/players
export const CREATE_PLACEHOLDER_PLAYER_PATH = '/hosted-games/{hostedGameId}/players' as const satisfies keyof paths;
type CreatePlaceholderPlayerOperation = paths[typeof CREATE_PLACEHOLDER_PLAYER_PATH]['post'];
export type CreatePlaceholderPlayerPathParams = CreatePlaceholderPlayerOperation['parameters']['path'];
export type CreatePlaceholderPlayerBody =
  CreatePlaceholderPlayerOperation['requestBody']['content']['application/json'];

// PUT /hosted-games/{hostedGameId}/players/{gamePlayerId}
export const UPDATE_PLACEHOLDER_PLAYER_PATH =
  '/hosted-games/{hostedGameId}/players/{gamePlayerId}' as const satisfies keyof paths;
type UpdatePlaceholderPlayerOperation = paths[typeof UPDATE_PLACEHOLDER_PLAYER_PATH]['put'];
export type UpdatePlaceholderPlayerPathParams = UpdatePlaceholderPlayerOperation['parameters']['path'];
export type UpdatePlaceholderPlayerBody =
  UpdatePlaceholderPlayerOperation['requestBody']['content']['application/json'];

// POST /hosted-games/{hostedGameId}/reassign/{reassignToken}
export const REASSIGN_GAME_BY_TOKEN_PATH =
  '/hosted-games/{hostedGameId}/reassign/{reassignToken}' as const satisfies keyof paths;
type ReassignGameByTokenOperation = paths[typeof REASSIGN_GAME_BY_TOKEN_PATH]['post'];
export type ReassignGameByTokenPathParams = ReassignGameByTokenOperation['parameters']['path'];

// POST /hosted-games/{hostedGameId}/reassign/create-reassign-token
export const GENERATE_REASSIGN_TOKEN_PATH =
  '/hosted-games/{hostedGameId}/reassign/create-reassign-token' as const satisfies keyof paths;
type GenerateReassignTokenOperation = paths[typeof GENERATE_REASSIGN_TOKEN_PATH]['post'];
export type GenerateReassignTokenPathParams = GenerateReassignTokenOperation['parameters']['path'];
export type GenerateReassignTokenResponse =
  GenerateReassignTokenOperation['responses'][200]['content']['application/json'];
